
<p class="filter-summary-item" (click)="showmore=!showmore">
  <span #contentComp [class.truncate]="!showmore"><b style="font-weight: bolder;">{{title}}:</b> {{content}} </span>
  @if (!showmore && isEllipsisActive(contentComp)) {
    <span class="show-more"><mat-icon>expand_more</mat-icon></span>
  }
  @if (showmore) {
    <span class="show-more"><mat-icon>expand_less</mat-icon></span>
  }
</p>
